import { Link, Typography } from '@mui/material';
import { useState } from 'react';

import { DatasetDetailsModal } from '../DatasetDetailsModal/DatasetDetailsModal';

export interface DatasetDetailsLinkProps {
  /** Release id of the dataset. Without one there are no details to open, so
   *  the name renders as plain text instead of a link. */
  releaseId?: string | null;
  /** Display name of the dataset; falls back to the release id, then `--`. */
  releaseName?: string | null;
  /** Testid for the rendered link (or the plain-text fallback). */
  testId?: string;
}

/**
 * A dataset's display name, opening the dataset-details modal (release date,
 * date range, patient count, data types) on click — the same affordance the
 * project header carries for the project's active dataset, sized for the line
 * under a project artifact's title.
 */
export const DatasetDetailsLink = ({ releaseId, releaseName, testId }: DatasetDetailsLinkProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const label = releaseName ?? releaseId ?? '--';

  if (!releaseId) {
    return (
      <Typography variant="body1" color="text.secondary" data-testid={testId}>
        {label}
      </Typography>
    );
  }

  return (
    <>
      <Link
        component="button"
        type="button"
        variant="body1"
        color="primary"
        underline="hover"
        onClick={() => setIsModalOpen(true)}
        data-testid={testId}
        sx={{ cursor: 'pointer', textAlign: 'left', overflowWrap: 'anywhere' }}
      >
        {label}
      </Link>
      {isModalOpen ? (
        <DatasetDetailsModal
          releaseId={releaseId}
          releaseName={releaseName ?? releaseId}
          onClose={() => setIsModalOpen(false)}
        />
      ) : null}
    </>
  );
};
